module.exports = __webpack_public_path__ + "static/media/ua.841d259d.svg";